export default "__VITE_ASSET__CDiv8_cW__"